import { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { EMPTY, Observable, throwError } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";

/**
 * Backend routes under /mpapi/public are declared unauthenticated (`security: []`),
 * but Quarkus runs proactive authentication: an Authorization header that is present
 * is validated before routing, so a stale or expired token turns a public endpoint
 * into a 401. Sending no header at all is what keeps them anonymous.
 */
const PUBLIC_API_PATH = /\/mpapi\/public(\/|$)/;

@Injectable()
export class StaqHttpInterceptor {
	constructor(private oidcSecurityService: OidcSecurityService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let reqHeaders = req.headers;

		if (req.url.includes("oauth2") || PUBLIC_API_PATH.test(req.url)) {
			return next.handle(req);
		}

		return this.oidcSecurityService.getAccessToken().pipe(
			switchMap(token => {
				if (token) {
					reqHeaders = reqHeaders.set("Authorization", `Bearer ${token}`);
				}
				const authReq = req.clone({
					headers: reqHeaders
				});
				return next.handle(authReq);
			}),
			catchError((err: any, _caught) => {
				if (err instanceof HttpErrorResponse) {
					return throwError(() => err);
				}
				return EMPTY;
			})
		);
	}
}
